import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Chart from '../../../components/chart/Chart'
import SalesTable from '../../../components/table/SalesTable'
import { Link, useParams } from 'react-router-dom'
import { collection, doc, getDocs } from 'firebase/firestore'
import { db } from '../../../firebase'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';



const Single = () => {


  const [header, setHeader] = useState("")

  const [hero, setHero] = useState("")

  const [heropic, setHeropic] = useState("")

  const [herotext, setHerotext] = useState("")

  const [subheading, setSubheading] = useState("")

  const [nuggets, setNuggets] = useState([])

  const [analythicData, setAnalythicData] = useState([])


  const getAnalythics = async() => {

    const querySnapshot = await getDocs(collection(db, "analythics"));

    querySnapshot.forEach((doc) => {



      console.log(doc.id, " => ", doc.data());

      setAnalythicData(doc.data())

    });


  }

  useEffect(() => {

    getAnalythics()

  }, [analythicData])


  console.log('analythics info', analythicData)


  // const getAnalythics = async() => {
  
  //       const docRef = doc(db, "analythics", user);
  
  //       const docSnap = await getDoc(docRef);
  
      
        
  //       if (docSnap.exists()) {
  
  //         setAdminData( docSnap.data())
  //         // console.log(userData)
  //       } else {
  //         // doc.data() will be undefined in this case
  //         console.log("No such document!");
  //       }
  // }
  
  // useEffect(()=>{

  //   getAnalythics()
    
  // }, [])




  // const []

  const params = useParams()

  console.log(params)
  
  return (
    <div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>

         <div style={{display:'flex', width:'100%', height:150, backgroundColor:'white', alignItems:'center'}}>
              <Link to={`/analythics`} style={{textDecoration:"none", display:'flex', alignItems:'center', paddingLeft:100}}>
                  <ArrowBackIcon style={{color:'black', marginRight:20}}/>
                  <h3 style={{color:'blac'}} >Back</h3>
              </Link>
          </div>
        <div className='body'>

                <div className="card">
                    <img src={analythicData.logo} alt="logo" width="150" height="150"/> 
                    <div className="headerContainer">
                        <h1 className="header">{analythicData.caption}</h1>
                    </div>  
                    
                    <div className="hero">
                        <div className="hero-title">
                            <h1 className="hero-text">
                                {analythicData.herotext}
                                {/* <!-- Actionable, fun-fact nuggets that are tailored to boost sales in hospitality businesses in Nigeria!  --> */}

                            </h1>
                        </div>
                        <div style={{ width:350, justifyContent:'flex-start'}}>
                            <img src={analythicData.heropic} alt="hero" width="350" height="200" resizemode="contain"/> 
                        </div>
                    </div>
                    
                    <div className="sub-heading">
                        <h1 className="sub-headinng-text"> {analythicData.subheading} </h1>
                    </div>

                          <div className="nuggets">

                        { analythicData.dataToSave !== null &&

                          analythicData.dataToSave?.map((item)=> (

                             <div key={item} className="nugget1">
                            <div className="nugget1-icon">
                                <img src={item.file} alt="logo" width="50"/> 
                            </div>
                            <div className="nugget1-text">
                                <h3 className="nugget1-text-message">
                                    {item.guidelinetext}
                                </h3>
                            </div>
                            </div>
                            
                          ))

                        }

                       
                    </div>

              

                      <div className="footerContainer">

                        <div className="footerlinks">
                          <h4 href="" className="footerlinks-link">info@chillaxianigeria.com</h4>
                          <a href="https://chillaxianigeria.com/" className="footerlinks-link">chillaxianigeria.com</a>
                        </div>
                        <div className="socials">
                          
                          <a className="links" href="">
                          <img src={analythicData.facebookicon} alt="logo" width="20"/>
                          </a>

                            <a className="links"  href="">
                             <img src={analythicData.instaicon} alt="logo" width="20"/>
                          </a>

                            <a className="links"  href="">
                               <img src={analythicData.tiktokicon} alt="logo" width="20"/>
                          </a>

                            <a className="links"  href="">
                             <img src={analythicData.linkedinicon} alt="logo" width="20"/>
                          </a>
                            <a className="links"  href="">
                            <img src={analythicData.twittericon} alt="logo" width="20"/>
                          </a>
                        </div>
                        
                    </div>  

                  
                </div>
        </div>
        {/* <div className="top">
          <div className="left">
            <div className="editbutton">Edit</div>
            <h2 className='title'>Information</h2>
            <div className='item'>
                <img
                    src="../photo/student4.jpg"
                    alt="avatar"
                    className="itemimg"
                />
                <div className="details">
                  <h3 className='itemTitle'>Chukwudi Johnson</h3>
                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>chukwudi@gmail.com</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Phone:</span>
                    <span className='itemValue'>+2348139444402</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Address:</span>
                    <span className='itemValue'>34 simpson st. Awka</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Gender:</span>
                    <span className='iitemValue'>Male</span>
                  </div>
                </div>
            </div>
          </div>
          <div className='right'>
            <Chart 
              aspect={3/1}
              title = "Customer purchase last 6 months"
            />
          </div>
        </div>
        <div className="bottom">
        <div className='listTitle'>Customer Lastest Transactions</div>
          <SalesTable/>
        </div> */}
      </div>
    </div>
  )
}

export default Single